import { CashbackContent } from './cashback-content';
import { CashbackMetaData as CashbackMetadata } from './cashback-metadata';

export class CashbackDetails {
    public cashbackMetadata: CashbackMetadata;
    public cashbackContent: CashbackContent;
}
